import apisauce from 'apisauce';
import { isNil } from '../helper';

const DEFAULT_TIMEOUT_MESSAGE = 'Der Server antwortet zur Zeit nicht. Bitte versuchen Sie es erneut.';
const DEFAULT_SERVER_MESSAGE = 'Es sind serverseitige Fehler aufgetreten. Bitte versuchen Sie es erneut.';
const DEFAULT_CLIENT_MESSAGE = 'Es konnten keine Informationen vom Server geladen werden, bitte versuchen Sie es später erneut.';
const DEFAULT_CONNECTION_MESSAGE = 'Leider ist der Server nicht verfügbar, bitte versuchen Sie es erneut.';
const DEFAULT_NETWORK_MESSAGE = 'Leider ist der Server nicht erreichbar, überprüfen Sie Ihre Internetverbindung.';
const DEFAULT_UNKNOWN_MESSAGE = 'Entschuldigt, dass etwas Seltsames passiert ist.';

// attach our monitor for a specific problem, and show a message
const registerMonitor = (api, problem, message) =>
    api.addMonitor(response => {
        if (response.problem === problem) {
            console.error(message);
        }
    });

const monitorTimeout = (api, message = DEFAULT_TIMEOUT_MESSAGE) =>
    registerMonitor(api, apisauce.TIMEOUT_ERROR, message);
const monitorServer = (api, message = DEFAULT_SERVER_MESSAGE) =>
    registerMonitor(api, apisauce.SERVER_ERROR, message);
const monitorConnection = (api, message = DEFAULT_CONNECTION_MESSAGE) =>
    registerMonitor(api, apisauce.CONNECTION_ERROR, message);
const monitorNetwork = (api, message = DEFAULT_NETWORK_MESSAGE) =>
    registerMonitor(api, apisauce.NETWORK_ERROR, message);
const monitorUnknown = (api, message = DEFAULT_UNKNOWN_MESSAGE) =>
    registerMonitor(api, apisauce.UNKNOWN_ERROR, message);
const monitorClient = (api, message = DEFAULT_CLIENT_MESSAGE) =>
    registerMonitor(api, apisauce.CLIENT_ERROR, message);

/*
 * Installs some monitors into an Apisauce API which
 * show human-friendly messages when errors occur.
 */
const addMonitors = api => {
    if (isNil(api)) return;

    // attach the monitors to each
    monitorTimeout(api);
    monitorServer(api);
    monitorClient(api);
    monitorConnection(api);
    monitorNetwork(api);
    monitorUnknown(api);
};

export default addMonitors;
